import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/header.scss';
import { MenuOutlined } from '@material-ui/icons';

const Header = () => {
    const [active, setActive] = useState(false);
    const showMenu = () => {
        setActive(!active);
    }

    return (
        <div className='header'>
            <a href = "/">
                <div className='logo' />
            </a>
            <div className='dropdown'>
                <div className='menu-icon'>
                    <MenuOutlined className='menu' onClick = { showMenu } />
                </div>

                <nav className={active ? "slider active" : "slider"}>
                    <ul className='ul'>
                        {/*<div className='closed'>
                            <Close className='close' onClick = { showMenu } />
                        </div>*/}

                        <li>
                            <Link to = '/home'>Home</Link>
                        </li>
                        <li>
                            <Link to = '/about'>About</Link>
                        </li>
                        <li>
                            <Link to = '/team'>Team</Link>
                        </li>
                        <li>
                            <Link to = '/roadmap'>Roadmap</Link>
                        </li>
                        <li>
                            <a href = 'https://gallery.lasercats.io'>Gallery</a>
                        </li>
                        {/*<li>
                            <Link to = '/tavern77'>Tavern77</Link>
                        </li>*/}
                        <li>
                            <a href = 'https://mint.lasercats.io'>Mint</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}

export default Header;